import { QueryClient } from '@tanstack/react-query';
import * as avatar from './avatar/avatar.query';
import * as users from './users/users.query';
import * as oauth from './oauth/oauth.query';
import * as documents from './documents/documents.query';
import * as settings from './settings/settings.query';
import * as catalogs from './catalogs/catalogs.query';
import * as prompts from './prompts/prompts.query';
import * as livekit from './livekit/livekit.query';
import * as threads from './threads/threads.query';
import * as summary from './summary/summary.query';
import * as messages from './messages/messages.query';
import * as memoryFacts from './memoryFacts/memoryFacts.query';
import * as memoryNotes from './memoryNotes/memoryNotes.query';
import * as memoryReminders from './memoryReminders/memoryReminders.query';
import * as agentTasks from './agentTasks/agentTasks.query';
import * as push from './push/push.query';
import * as devices from './devices/devices.query';
import * as userSync from './userSync/userSync.query';
import * as threadsUpdate from './threads/threads.query.update';
import * as documentsUpdate from './documents/documents.query.update';
import * as promptRecords from './promptRecords/promptRecords.query';
import * as cameras from './cameras/cameras.query';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            networkMode: 'always',
            staleTime: 1000 * 60 * 10,
            retryDelay: 2 * 1000, // 2s between retries
            retry: 3
        }
    }
});
export const invalidateQueryClient = async () => {
    await queryClient.invalidateQueries().then();
    queryClient.clear();
};
export * from './request';
export * from './avatar';
export * from './oauth';
export * from './documents';
export * from './settings';
export * from './catalogs';
export * from './prompts';
export * from './threads';
export * from './livekit';
export * from './users';
export * from './summary';
export * from './messages';
export * from './memoryFacts';
export * from './memoryNotes';
export * from './memoryReminders';
export * from './agentTasks';
export * from './push';
export * from './devices';
export * from './userSync';
export * from './promptRecords';
export * from './cameras';
export const api = {
    avatar,
    users,
    documents,
    settings,
    catalogs,
    prompts,
    threads,
    livekit,
    oauth,
    summary,
    messages,
    memoryFacts,
    memoryNotes,
    memoryReminders,
    agentTasks,
    push,
    devices,
    userSync,
    promptRecords,
    cameras,
    updater: {
        threads: threadsUpdate,
        documents: documentsUpdate
    }
};
//# sourceMappingURL=index.js.map